import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/Product.vue'
import TermsOfUse from '../views/TermsOfUse.vue' // kb 58598

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // a rota abaixo foi inserida no kb 58598:
  {
    path: '/read-terms-of-use',
    component: TermsOfUse
  },
  {
    path: '/:slug',
    component: Product
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
